export const colors = {
  primary: '#65C3E9',
  primaryHover: '#4AAED4',
  black: '#000000', // Main “Black”
  blackHover: '#292929',
  gray1: '#505050', // Secondary text color & COL gray
  gray2: '#707070', // Icons, labels
  gray3: '#DFDFDF', // Dividers, dark Borders
  gray4: '#EDEDED', // Good for delimiters / light border
  gray5: '#F7F7F7', // Hover color
  offWhite: '#F8F8F8', // Pill on dark background
  white: '#FFFFFF',
  blue: '#005FB2',
  red: '#CC2222',
  redDark: '#A81C1C',
  lightRed: '#FF3333',
  pink: '#fae9e9',
  green: '#218321',
  amber: '#E6A800',
  amberLight: '#FFF3CD',
  amberDark: '#664D03',
  yellow: '#FF9900',
  blueLight: '#E8F4FD',
} as const;

export type ColorKeys = keyof typeof colors;
export type Color = (typeof colors)[ColorKeys];
